import React from 'react';
import './Admission.css';
import AdmissionForm from "./photos/Admission Form.pdf";

const Admission = () => {
  return (
    <div className="main-container-Admission">
  
      <div className='add'>
        <div className="Admission">
          <div data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">
            <h1 className="animate slide-left delay-2">ADMISSION PROCEDURE D.PHARMACY </h1>
          </div>

          <div data-aos="fade-up" data-aos-duration="3000">
            <section>
              <h2 className="animate slide-left delay-3">ELIGIBILITY CRITERIA</h2>
              <div className="container-admission">
                <p className="animate slide-left delay-4">Students seeking admission in D.Pharma should 
                have passed class 12th from any recognized. Board/University with 50% in PCM/PCB</p>
                <div className="photos01">
                
                </div>
              </div>
            </section>
          </div>

          <div data-aos="fade-up" data-aos-duration="3000">
            <section>
              <h2 className="animate slide-left delay-5">HOW TO APPLY</h2>
              <div className="container-admission1">
                <p className="animate slide-left delay-6">
                  The prospectus cum admission form can be obtained from our admission office or college campus. The form can also be download form below the download button and should be sent with a demand draft of Rs. 550/- in favor of "Pandit L . R. School of Pharmacy" payable at Ballabhgarh, Faridabad.
                </p>
                <div className="photos01">
              
                </div>
              </div>
            </section>
          </div>

          {/* <div data-aos="fade-up" data-aos-duration="3000">
            <section>
              <h2 className="animate slide-left delay-7">ADMISSION TO LATERAL ENTRY IN B.TECH</h2>
              <div className="container-admission2">
                <p className="animate slide-left delay-8">20% of sanctioned seats and vacant seats, if any, are to be filled directly in the 2nd years (3rd semester) through counselling by HSCS.</p>
              </div>
            </section>
          </div> */}

          {/* <div data-aos="fade-up" data-aos-duration="3000">
            <section>
              <h2 className="animate slide-left delay-9">ADMISSION PROCESS</h2>
              <div className="container-admission4">
                <p className="animate slide-left delay-10">
                  1) Admission shall be made on the basis of merit obtained by the student in the Joint Entrance Examination (JEE). <br />
                  2) Seats will be filled by the Haryana State Counselling Society (HSCS) through online counselling. <br />
                  3) Admission to the college will be governed by rules stated in the information bulletin of HSCS. <br />
                  4) Students have to fill the admission form attached in the prospectus of Pt. L. R. School of Pharmacy.
                </p>
                <div className="photos01">
                
                </div>
              </div>
            </section>
          </div>

        
          <section>
            <div data-aos="fade-up" data-aos-duration="1000">
              <h2 className="animate slide-left delay-2">ELIGIBILITY CRITERIA FOR DIPLOMA</h2>
              <div className="container-admission5">
                <p className="animate slide-left delay-3">Students seeking admission in the first years should have passed class 10th from any recognized Board/University.</p>
                <div className="photos01">
             
                </div>
              </div>
            </div>

            <div data-aos="fade-up" data-aos-duration="1000">
              <h2 className="animate slide-left delay-4">ADMISSION TO LATERAL ENTRY IN DIPLOMA</h2>
              <div className="container-admission5">
                <p className="animate slide-left delay-5">20% of sanctioned seats and vacant seats, if any, are to be filled directly in the 2nd years (3rd semester) through counselling by HSCS. Students must have obtained 45% marks in aggregate in Diploma in Engineering/Technology of 3 yearss or more from HSBTE or its equivalent, or a B.Sc. with Mathematics from a recognized university.</p>
                <div className="photos01">
                
                </div>
              </div>
            </div>
          </section>*/}

        </div> 

        <div data-aos="fade-up" data-aos-duration="3000">
          <section>
            <button className="cssbuttons-io-button">
              <a href={AdmissionForm} download="AdmissionForm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="-0 1 20 20"
                  width="50"
                  height="25"
                >
                  <path fill="none" d="M0 0h24v24H0z"></path>
                  <path
                    fill="currentColor"
                    d="M1 14.5a6.496 6.496 0 0 1 3.064-5.519 8.001 8.001 0 0 1 15.872 0 6.5 6.5 0 0 1-2.936 12L7 21c-3.356-.274-6-3.078-6-6.5zm15.848 4.487a4.5 4.5 0 0 0 2.03-8.309l-.807-.503-.12-.942a6.001 6.001 0 0 0-11.903 0l-.12.942-.805.503a4.5 4.5 0 0 0 2.029 8.309l.173.013h9.35l.173-.013zM13 12h3l-4 5-4-5h3V8h2v4z"
                  ></path>
                </svg>
                Click To Download Admission Form
              </a>
            </button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Admission;
